export const scrollToElement = (elementSelector, callback) => {
    let element = document.querySelector(elementSelector);

    if (element) {
        // Calculate the distance to scroll
        let offsetTop = element.getBoundingClientRect().top;
        let scrollDistance = window.scrollY + offsetTop;

        // Animation duration in milliseconds
        let duration = 500; // Adjust as needed

        // Start time of the animation
        let startTime = null;

        function animateScroll(time) {
            if (!startTime) {
                startTime = time;
            }

            // Calculate the progress of the animation
            let progress = (time - startTime) / duration;
            if (progress > 1) {
                progress = 1;
            }

            // Calculate the new scroll position
            let newPosition = window.scrollY + (scrollDistance - window.scrollY) * progress;

            // Scroll to the new position
            window.scrollTo(0, newPosition);

            // Continue the animation if not complete
            if (progress < 1) {
                requestAnimationFrame(animateScroll);
            } else {
                // Animation complete, execute the callback
                if (callback && typeof callback === 'function') {
                    callback();
                }
            }
        }

        // Start the animation
        requestAnimationFrame(animateScroll);
    }
}

export const smoothNavigate = (callback = () => {}, section = '#contact-section') => {
    scrollToElement(section, () => {
        setTimeout(() => callback(), 100);
    });
}
